import Login from '@/views/intranet/login/Login.vue'
import LoginToken from '@/views/intranet/login/LoginToken.vue'


export const login = {
  path: '/login',
  name: 'Login',
  component: Login,
};

export const loginPassRecover = {
  path: "/Login/:token/:key",
  name: "Login-token",
  component: LoginToken
}